import { Controller } from "@hotwired/stimulus";

// Shared modal used on the custom-figure edit page to collect an email
// address when sending an invite to a collaborator that doesn't have one
// on file yet. Lives on a wrapper that survives turbo-stream updates of
// the collaborators list inside it, so the modal element stays mounted
// even as individual rows re-render.
//
// "Invite" buttons in the list partial trigger #open with three params
// (collaboratorId, role, name); the controller stuffs those into the
// modal's hidden inputs and label, reveals the modal, and focuses the
// email field. Submission is a regular Turbo POST that redirects back
// to the edit page, which naturally tears the modal down.
//
// Targets:
//   modal           - the fixed overlay element
//   collaboratorId  - hidden input that gets the collaborator's id
//   role            - hidden input that mirrors the row's role
//   emailInput      - the email field (focused on open)
//   name            - inline span that gets the collaborator's name
export default class extends Controller {
  static targets = ["modal", "collaboratorId", "role", "emailInput", "name"];

  open(event) {
    event?.preventDefault();
    const { collaboratorId, role, name } = event.params || {};
    if (this.hasCollaboratorIdTarget) this.collaboratorIdTarget.value = collaboratorId || "";
    if (this.hasRoleTarget) this.roleTarget.value = role || "";
    if (this.hasNameTarget) this.nameTarget.textContent = name || "this collaborator";
    if (this.hasEmailInputTarget) this.emailInputTarget.value = "";

    this.modalTarget.classList.remove("hidden");
    document.body.classList.add("overflow-hidden");
    setTimeout(() => this.emailInputTarget?.focus(), 50);
  }

  close(event) {
    event?.preventDefault();
    this.modalTarget.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");
  }

  // Only close when the click landed on the backdrop itself, not when
  // it bubbled up from the inner panel.
  backdropClose(event) {
    if (event.target === event.currentTarget) {
      this.close();
    }
  }

  keydown(event) {
    if (event.key === "Escape" && !this.modalTarget.classList.contains("hidden")) {
      this.close();
    }
  }
}
